import clsx from 'clsx';

const Section = ({
    id,
    className,
    children,
    background = 'white' // 'white', 'cream', 'dark'
}) => {
    const bgColors = {
        white: 'bg-white',
        cream: 'bg-secondary-cream',
        dark: 'bg-primary-black text-white'
    };

    return (
        <section
            id={id}
            className={clsx(
                'py-20 md:py-32 relative overflow-hidden',
                bgColors[background],
                className
            )}
        >
            <div className="container mx-auto px-4 md:px-6 relative z-10">
                {children}
            </div>
        </section>
    );
};

export default Section;
